import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { Dropdown } from 'office-ui-fabric-react/lib/Dropdown';
import selectFirstWeekOfYearOption from '../data/mutators/selectFirstWeekOfYearOption';
import { observer } from 'mobx-react';
import getFirstWeekOfYear from '../selectors/getFirstWeekOfYear';
var styles = require('./AppearanceFull.scss');
/**
 * FirstWeekOfYear parameter specifies the first week of the year. Valid values are:
 * a. FirstDay (Week numbers start on the first day of the year. This is the default value)
 * b. FirstFourDayWeek (Week numbers start on the first week that has at least four days)
 * c. FirstFullWeek (Week numbers start on the first week that has seven days)
 * d. LegacyNotSet (You can't set this value. This is a null value that appears only when
      the mailbox has been moved from an earlier version of Exchange. If a LegacyNotSet value
      comes we simply show the default value i.e FirstDay
 */
export default observer(function FirstWeekOfYear() {
    var firstWeekOfYear = getFirstWeekOfYear();
    var firstWeekOfYearOptions = [
        {
            key: 1 /* FirstDay */,
            text: strings.options_weekNumbers_firstWeekOfYear_firstDay,
        },
        {
            key: 2 /* FirstFourDayWeek */,
            text: strings.options_weekNumbers_firstWeekOfYear_firstFourDayWeek,
        },
        {
            key: 3 /* FirstFullWeek */,
            text: strings.options_weekNumbers_firstWeekOfYear_firstFullWeek,
        },
    ];
    var onFirstWeekOfYearChange = function (option) {
        selectFirstWeekOfYearOption(option.key);
    };
    return (React.createElement("div", { className: styles.firstWeekOfYear },
        React.createElement(Dropdown, { selectedKey: firstWeekOfYear, ariaLabel: strings.options_weekNumbers_firstWeekOfYear, label: strings.options_weekNumbers_firstWeekOfYear, options: firstWeekOfYearOptions, onChanged: onFirstWeekOfYearChange })));
});
//# sourceMappingURL=FirstWeekOfYear.js.map